import React from "react";
import { Button, Col, Row } from "antd";

export default class ViewerPdf extends React.Component {
  constructor() {
    super();
    this.state = {
      pageNum: 1,
      pageRendering: false
    };
    this.pageNumPending = null;
  }

  /**
   * Get page info from document, resize canvas accordingly, and render page.
   * @param num Page number.
   */
  renderPage(num) {
    this.setState({ pageRendering: true, pageNum: num }, () => {
      // Using promise to fetch the page
      this.props.doc.getPage(num).then(page => {
        let viewport = page.getViewport(1);
        this.canvas.height =
          (viewport.height * this.canvas.width) / viewport.width;

        // Render PDF page into canvas context
        let renderContext = {
          canvasContext: this.ctx,
          viewport: page.getViewport(this.canvas.width / viewport.width)
        };
        let renderTask = page.render(renderContext);

        // Wait for rendering to finish
        renderTask.promise.then(() => {
          this.setState({ pageRendering: false });
          if (this.pageNumPending !== null) {
            // New page rendering is pending
            this.renderPage(this.pageNumPending);
            this.pageNumPending = null;
          }
        });
      });
    });
  }

  /**
   * If another page rendering in progress, waits until the rendering is
   * finised. Otherwise, executes rendering immediately.
   */
  queueRenderPage(num) {
    if (this.pageRendering) {
      this.pageNumPending = num;
    } else {
      this.renderPage(num);
    }
  }

  /**
   * Displays previous page.
   */
  handlePrevPage = () => {
    if (this.state.pageNum <= 1) {
      return;
    }
    this.queueRenderPage(this.state.pageNum - 1);
  };

  /**
   * Displays next page.
   */
  handleNextPage = () => {
    if (this.state.pageNum >= this.props.doc.numPages) {
      return;
    }
    this.queueRenderPage(this.state.pageNum + 1);
  };

  componentDidMount() {
    this.canvas.width = 380;
    this.ctx = this.canvas.getContext("2d");
    this.renderPage(1);
  }

  render() {
    const { doc } = this.props;
    return (
      <div id="viewerContainer" ref={this.refContainer}>
        <Row style={{ marginBottom: "8px" }}>
          <Col span={8}>
            <Button
              disabled={this.state.pageRendering || this.state.pageNum <= 1}
              onClick={this.handlePrevPage}
              size="small"
              style={{ float: "right" }}
              type="primary"
            >
              {"前のページ"}
            </Button>
          </Col>
          <Col span={8} className="txt-center">
            <div>
              ページ: <span id="page_num">{this.state.pageNum}</span> /{" "}
              <span id="page_count">{doc.numPages}</span>
            </div>
          </Col>
          <Col span={8}>
            <Button
              disabled={
                this.state.pageRendering || this.state.pageNum >= doc.numPages
              }
              onClick={this.handleNextPage}
              size="small"
              type="primary"
            >
              {"次のページ"}
            </Button>
          </Col>
        </Row>
        <canvas
          style={{ display: this.state.pageRendering ? "none" : "inline" }}
          ref={i => (this.canvas = i)}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pdfPreview/ViewerPdf.js